import { NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { environment } from "../environments/environment";
import { initializeApp, provideFirebaseApp } from "@angular/fire/app";
import { provideFirestore, getFirestore } from "@angular/fire/firestore";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { HelpersModule } from "./helpers/helpers.module";
import { AngularFirestoreModule } from "@angular/fire/compat/firestore";
import { AngularFireModule } from "@angular/fire/compat";
import { NgxsModule } from "@ngxs/store";
import { NgxsRouterPluginModule } from "@ngxs/router-plugin";
import { UserState } from "./states/user.state";
import { MatSidenavModule } from "@angular/material/sidenav";
import { ClientState } from "./states/client.state";
import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from "@angular/material/button";
import { HttpClientModule } from "@angular/common/http";
import { MatToolbarModule } from "@angular/material/toolbar";
import { ReportState } from "./states/report.state";
import { provideStorage, getStorage } from "@angular/fire/storage";
import { SubtaskState } from "./states/subtask.state";
import { AssetState } from "./states/asset.state";
import { MailState } from "./states/mail.state";
import { HourState } from "./states/hours.state";
import { CookieService } from "ngx-cookie-service";

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    AppRoutingModule,
    provideFirebaseApp(() => initializeApp(environment.firebase)),
    provideFirestore(() => getFirestore()),
    BrowserAnimationsModule,
    HelpersModule,
    MatMenuModule,
    MatButtonModule,
    MatSidenavModule,
    MatToolbarModule,
    NgxsRouterPluginModule.forRoot(),
    provideFirestore(() => getFirestore()),
    NgxsModule.forRoot([
      HourState,
      UserState,
      ClientState,
      ReportState,
      SubtaskState,
      AssetState,
      MailState,
    ]),
    AngularFireModule.initializeApp(environment.firebase),
    AngularFirestoreModule,
    HttpClientModule,
    provideStorage(() => getStorage()),
  ],
  providers: [CookieService],
  bootstrap: [AppComponent],
  exports: [],
})
export class AppModule {}
